import React, { useEffect, useMemo, useRef, useState } from 'react';
import { SeatmapSeat } from '@arema/components/Classes';
import classNames from 'classnames';
import { Button, Icon, Modal } from 'react-frontier2';
import { bindClick } from '@arema/components/Util';

export interface SeatGhost{
	x: number,
	y: number,
}

enum PaintMode{
	PAINTING = 1,
	ERASING = 2,
}

interface SeatmapDrawProps{
	open: boolean,
	onClose: ()=>void,
	map: SeatmapSeat[][],
	ghosts: SeatGhost[],
	onChange: (g: SeatGhost[])=>void
}

const SEAT_SIZE = {
	width: 30,
	height: 30,
	gap: 3,
}

var SeatmapDrawModal = (props: SeatmapDrawProps)=>{
	var [ghostBuffer, setGhostBuffer] = useState<SeatGhost[]>([]);
	var [painting, setPainting] = useState<boolean>(false);
	var [paintMode, setPaintMode] = useState<PaintMode>(PaintMode.PAINTING);
	var cornerRef = useRef<HTMLDivElement>(null);
	
	var onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>)=>{
		setPainting(true);
		setGhostBuffer(props.ghosts);
		onMouseMove(e, true);
	}

	var getSeatCoordsFromCoords = (x: number, y: number)=>{
		var { x: smX, y: smY } = cornerRef.current?.getBoundingClientRect();

		if(!props.map || props.map.length==0) return null;
		var seat_x = Math.floor((x-smX)/(SEAT_SIZE.width+SEAT_SIZE.gap));
		var seat_y = Math.floor((y-smY)/(SEAT_SIZE.height+SEAT_SIZE.gap));
		if(seat_x<0 || seat_y<0) return null;
		if(seat_x>=props.map[0].length || seat_y>=props.map.length) return null;
		// seat_x = seat_x >= seatmap.seats_width ? (seatmap.seats_width-1) : seat_x;
		// seat_y = seat_y >= seatmap.seats_height ? (seatmap.seats_height-1) : seat_y;
		return {
			x: seat_x,
			y: seat_y,
		}
	}

	var onMouseMove = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, force: boolean=false)=>{
		if(!painting && !force) return;
		var mouseX = e.clientX, mouseY = e.clientY;

		var coords = getSeatCoordsFromCoords(mouseX, mouseY);
		if(!coords) return;
		// var seat_x = Math.floor((mouseX-cornerPos.x)/(SEAT_SIZE.width+SEAT_SIZE.gap));
		// var seat_y = Math.floor((mouseY-cornerPos.y)/(SEAT_SIZE.height+SEAT_SIZE.gap));
		var ghosts = [...ghostBuffer];
		var ghix = ghosts.findIndex(a=>a.x===coords.x && a.y===coords.y);

		var changed = false;
		if(paintMode===PaintMode.PAINTING){
			if(ghix==-1){
				ghosts.push({ x: coords.x, y: coords.y });
				changed = true;
			}
		}else if(paintMode===PaintMode.ERASING){
			if(ghix!=-1){
				ghosts.splice(ghix, 1);
				changed = true;
			}
		}
		if(changed){
			setGhostBuffer(ghosts);
		}
	}
	
	var onMouseUp = (e: React.MouseEvent<HTMLDivElement, MouseEvent>)=>{
		setPainting(false);
		props.onChange(ghostBuffer);
	}

	if(!props.map) return;
	return <Modal open={props.open} onClose={props.onClose} className='seatmap-edit-draw'>
		<Modal.Header>Dibujar butacas</Modal.Header>
		<div className="toolbar">
			<Button text='Dibujar' color={paintMode===PaintMode.PAINTING ? 'black' : null} iconName='pen' onClick={bindClick(setPaintMode, PaintMode.PAINTING)} />
			<Button text='Borrar' color={paintMode===PaintMode.ERASING ? 'black' : null} iconName='eraser' onClick={bindClick(setPaintMode, PaintMode.ERASING)} />
			<Button text='Vaciar' iconName='ban' onClick={()=>props.onChange([])} />
		</div>
		<Modal.Content>
			<div className='ar seat-draw' onMouseDown={onMouseDown} onMouseMove={onMouseMove} onMouseUp={onMouseUp} onMouseLeave={onMouseUp}>
				{props.map.map((a, y)=>(
					<div className="row" key={`ghosts-${y}`}>
						{a.map((b, x)=>{
							var ghost = !b ? (painting ? ghostBuffer : props.ghosts).findIndex(a=>a.x===x && a.y===y)!=-1 : false;
							return (
								<div ref={(x==0 && y==0) ? cornerRef : null} className={classNames('ghost', {
									seat: !!b,
									selected: ghost
								})} key={`ghosts-${y}x${x}`}>
									{!!b ? (
										<Icon name='chair' />
									) : (
										null
									)}
								</div>
							)
						})}
					</div>
				))}
			</div>
		</Modal.Content>
		<Modal.Actions>
			<Button text='Cerrar' color='black' onClick={props.onClose} />
		</Modal.Actions>
	</Modal>
}

export default SeatmapDrawModal;